
import qs from "qs";
import {Dialog, Toast} from "vant";

export default {
  data() {
    return {
      clientTaskInfo: [],
      id:1,
      clNo: '',
    }
  },
  mounted() {
    this.id = this.$route.query.id
    this.clNo = this.$route.query.clNo
    const tabbar = document.querySelector('.van-tabbar')
    tabbar.style.display = 'none'
    this.getClientInfo()
    document.title = this.$t('append_field.bind_task')
  },
  methods: {
    getClientInfo() {
      this.$ajax.post('/etv/selectClientCommonTaskByClId.json', qs.stringify({
        id: this.id,
      })).then(res => {
        if (res.data.code === 0) {
          this.clientTaskInfo = res.data.data.taskList
        }
      })

    },
    deleteTask(data) {
      Dialog.confirm({
        title: this.$t('append_field.delete')
        , message: this.$t('append_field.confirm_delete_task'),
      }).then(() => {
        this.$ajax.post('/etv/deleteCommonTaskByClientId.json', qs.stringify({
          id: this.id,
          taskId: data.id
        })).then(res => {
          if (res.data.code === 0) {
            Toast(this.$t('append_field.delete_success'))
            this.getClientInfo()
          } else {
            Toast(res.data.msg)
          }
        })
      }).catch(() => {
      })
    },
    back() {
      this.$router.back()
    }
  }

}
